import angular from 'angular';

angular.module('cloudX').directive('cxSubSection', function() {
  return {
    restrict: 'E',
    template: require('./subSection.html'),
    scope: {
      section: '=data',
      relId: '@',
    },
    controller: 'SectionCtrl',
  };
});
